import React from "react";

type RoleToggleTabsProps = {
  options: string[];
  active: string;
  onChange: (value: string) => void;
};

const RoleToggleTabs: React.FC<RoleToggleTabsProps> = ({
  options,
  active,
  onChange,
}) => {
  return (
    <div className="flex items-end rounded-t-2xl">
      {options.map((opt) => {
        const isActive = active === opt;

        return (
          <div
            key={opt}
            onClick={() => onChange(opt)}
            className={`
              flex items-center w-44 cursor-pointer px-4 py-4
              rounded-t-xl transition-all select-none
              ${isActive ? "bg-[#F7F6F2] text-[#212121]" : " text-[#212121]/70"}
            `}
          >
            <div className="flex-1 truncate text-sm font-medium">{opt}</div>
          </div>
        );
      })}
    </div>
  );
};

export default RoleToggleTabs;
